// The per-turn checks of one sweep (or every sweep): the prompt, the
// faithfulness verdict + reason, the replay verdict. Filterable by verdict.

import type { WatchdogCheckRead } from '../../services/fastpathQuality';
import { whenUtc } from './format';
import styles from '../FastpathQualityPage.module.css';

export const WATCHDOG_VERDICTS = ['faithful', 'unfaithful', 'no_answer', 'unjudgeable'] as const;

interface Props {
  checks: WatchdogCheckRead[];
  total: number;
  verdict: string;
  onVerdictChange: (verdict: string) => void;
  runLabel: string;
}

export function WatchdogChecksTable({ checks, total, verdict, onVerdictChange, runLabel }: Props) {
  return (
    <section className={styles.panel} aria-label="Watchdog checks">
      <div className={styles.panelHead}>
        <h2>Checks · {runLabel}</h2>
        <label className={styles.meta}>
          verdict{' '}
          <select value={verdict} onChange={(e) => onVerdictChange(e.target.value)} aria-label="Verdict filter">
            <option value="">all</option>
            {WATCHDOG_VERDICTS.map((v) => <option key={v} value={v}>{v}</option>)}
          </select>
          {' '}· <span data-testid="checks-total">{`${total} match${total === 1 ? '' : 'es'}`}</span>
        </label>
      </div>
      {checks.length === 0 ? (
        <p className={styles.empty}>No check matches.</p>
      ) : (
        <div className={styles.tableWrap}>
          <table className={styles.table}>
            <thead>
              <tr>
                <th>judged</th>
                <th>verdict</th>
                <th>prompt</th>
                <th>reason</th>
                <th>replay</th>
                <th>conversation</th>
              </tr>
            </thead>
            <tbody>
              {checks.map((c) => (
                <tr key={c.id} data-verdict={c.verdict}>
                  <td>{whenUtc(c.created_at)}</td>
                  <td><span className={`${styles.chip} ${styles[`verdict_${c.verdict}`] ?? ''}`}>{c.verdict}</span></td>
                  <td className={styles.wrap}>{c.prompt}</td>
                  <td className={styles.wrap}>{c.reason ?? '–'}</td>
                  <td className={styles.wrap} title={c.replay_reason ?? undefined}>
                    {c.replay_verdict ? <span className={`${styles.chip} ${styles[`replay_${c.replay_verdict}`] ?? ''}`}>{c.replay_verdict}</span> : '–'}
                  </td>
                  <td><code className={styles.tag}>{c.conversation_id.slice(0, 8)}</code></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
}
